import { Icon } from "@iconify/react";
import React from "react";
import { Nav } from "react-bootstrap";

const TemplateFilter = ({ text, onChange }) => {
  return (
    <form className="filterTemplate ">
      <div className="relative ">
        <input
          type="text"
          value={text}
          onChange={(e) => onChange(e.target.value)}
          className="form-control"
          placeholder="Search"
        />
        <i>
          <Icon icon="ep:search" />
        </i>
      </div>
      {/* <Nav className="justify-content-end cta_square">
        <Nav.Item>
          <button>
            <Icon icon="iconoir:filter" />
          </button>
        </Nav.Item>
      </Nav> */}
    </form>
  );
};

export default TemplateFilter;
